import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const LoginCard = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="430"
    height="357"
    viewBox="0 0 430 357"
    className={className}
  >
    <g fill="none" fillRule="nonzero" transform="translate(-13)">
      <ellipse cx="171" cy="171.5" fill="#F2F2F2" rx="158" ry="171.5" />
      <path
        fill={Colors.primary}
        d="M133.646 134.812l.354.516A171.863 171.863 0 0 0 130.114 124l-19.944 48.185-.17-.228c.505 2.37.97 4.718 1.395 7.043l22.251-44.188z"
      />
      <path
        fill="#6C63FF"
        d="M129.646 123.023l.354.491A170.159 170.159 0 0 0 121.292 104L106 152.613A302.742 302.742 0 0 1 110.492 171l19.154-47.977zM111 180.934c.127.726.258 1.454.378 2.175a208.425 208.425 0 0 1 2.42 20.891l23.866-42.04.336.516a82.546 82.546 0 0 0-2.411-19.184 168.96 168.96 0 0 0-2.012-7.292L111 180.934z"
      />
      <path fill="#2F2E41" d="M49 357s101.923-45 225 0" />
      <path
        fill="#FFB9B9"
        d="M123.068 323.036c.078 1.135.21 2.265.397 3.386 0 0 8.725 6.264 9.423-.737.454-4.56-.572-6.62-1.347-7.501l-.012-.014a2.922 2.922 0 0 1-.735-1.921V308l-7.678 2.58.35 7c-.517 1.455-.524 3.629-.398 5.456z"
      />
      <path
        fill="#000"
        d="M123 323.174c.079 1.11.213 2.213.4 3.308 0 0 8.785 6.119 9.488-.72.456-4.456-.577-6.467-1.357-7.328a2.058 2.058 0 0 0-2.157-.23c-1.406-.64-2.952.428-4.23 1.81a12.734 12.734 0 0 0-2.144 3.16z"
        opacity=".05"
      />
      <path
        fill="#2F2E41"
        d="M129.655 319.213s3.797-2.245 4.488 7.856c.69 10.1 1.035 8.978 1.035 8.978s3.453 8.978-3.797 7.856c-7.25-1.122-10.703-1.87-10.357-6.36.208-2.706.792-6.634 1.223-9.329.412-2.669 1.542-5.147 3.25-7.121 1.26-1.437 2.777-2.546 4.158-1.88z"
      />
      <path
        fill="#FFB9B9"
        d="M170.985 331.654l3.911 2.09s12.22 2.08 8.344-5.631a33.401 33.401 0 0 1-2.548-7.295A53.534 53.534 0 0 1 179.339 310L169 311.598c3.371 4.975 2.944 13.045 2.423 17.272a37.42 37.42 0 0 1-.438 2.784z"
      />
      <path
        fill="#000"
        d="M171 331.687l4.207 2.061s13.145 2.05 8.976-5.554a31.154 31.154 0 0 1-2.742-7.194c-2.553.5-4.496 4.233-4.496 4.233-2.06 7.263-3.912 5.448-5.474 3.708a34.084 34.084 0 0 1-.471 2.746z"
        opacity=".05"
      />
      <path
        fill="#2F2E41"
        d="M176.552 326.316s3.138-6.331 6.62-3.657c3.48 2.674 1.753 6.494 13.027 10.235 11.275 3.741 3.824 11.68-3.075 11.073-6.898-.606-21.605-3.465-21.605-3.465s-3.824-11.68-2.05-11.944c1.775-.264 4.224 8.354 7.083-2.242z"
      />
      <path
        fill="#FFF"
        d="M192.64 342.472c4.49.416 9.21-2.968 8.879-6.472 2.146 3.957-3.286 8.44-8.415 7.965-6.915-.64-21.66-3.654-21.66-3.654s-.18-.58-.444-1.49c.43.088 14.828 3.021 21.64 3.651zM121.041 337c.399 3.53 3.844 4.273 10.341 5.328 3.304.537 4.383-1.128 4.581-3.099.216 2.524-.415 5.346-4.581 4.67-7.25-1.178-10.704-1.963-10.358-6.673l.017-.226z"
        opacity=".3"
      />
      <path
        fill="#FBBEBE"
        d="M104.262 189.033l-1.22 19.062s-.978 19.316 6.593 20.84c7.571 1.526 0-24.652 0-24.652V187l-5.373 2.033z"
      />
      <path
        fill="#3F3D56"
        d="M110.614 120l-.95 2.25s.238 15.756 0 17.007c-.238 1.25-3.326 11.004-3.326 12.004s-2.376 30.01-2.851 31.762c-.475 1.75-2.614 7.252-.713 8.002 1.9.75 5.464-2.25 6.89 0 1.425 2.251 2.613 0 2.613-.75s.476-15.005 3.327-19.007c2.85-4.001 5.464-13.004 5.94-14.755.474-1.75 1.187-27.01 1.425-27.51.237-.5-.95-7.252-.95-7.252L110.613 120z"
      />
      <path
        fill="#2F2E41"
        d="M124.531 146s-2.788 11.901-4.647 14.18c-1.86 2.28-11.155 19.245-8.366 41.78 2.788 22.537 7.668 51.91 7.668 51.91s.698 10.382-.232 13.167c-.93 2.786 4.183 47.099 4.183 47.099s7.204 6.077 11.154-1.52c0 0-.93-16.459 0-17.978.93-1.52 0-28.867 0-28.867s.697-68.115 4.416-65.33c3.718 2.786 15.104 50.137 15.104 50.137s4.88 18.232 4.648 19.751c-.232 1.52 4.183 20.51 4.183 20.51s4.183 26.335 5.81 26.842c1.626.506 11.618.76 12.548-2.026l-2.789-23.802s-2.788-27.095-4.182-30.893c-1.395-3.798-3.719-57.733-10.458-73.686 0 0-2.556-25.575-4.415-29.373 0 0-1.09-5.218.255-10.09 0 0-32.324.215-34.88-1.811z"
      />
      <ellipse cx="137.5" cy="72" fill="#2F2E41" rx="19.5" ry="27" />
      <path
        fill="#FBBEBE"
        d="M179 103.107l-3.04 7.091-36.014 11.396s-25.022 7.85-27.595-4.812c-2.572-12.662 9.822-13.928 9.822-13.928s4.677-3.546 10.524-7.091c1.955-1.188 2.603-3.11 2.598-5.144a11.5 11.5 0 0 0-.157-1.803 16.308 16.308 0 0 0-.468-2.03 24.25 24.25 0 0 0-1.973-4.699s15.434-6.584 15.2-3.039a10.874 10.874 0 0 0 .374 3.789c.32 1.073.75 2.104 1.284 3.072.262.489.555.995.88 1.532.42.696.9 1.438 1.438 2.244 3.04 4.558 13.096 4.558 13.096 4.558 7.95-1.013 14.031 8.864 14.031 8.864zM215.945 144s16.956 13.296 20.253 13.045c3.297-.251 22.607-1.505 18.133 3.261-4.474 4.767-24.727 1.756-24.727 1.756L211 149.52l4.945-5.519z"
      />
      <path
        fill="#000"
        d="M147 83.628c-3.343 3.838-8.42 5.303-13.1 3.778a23.122 23.122 0 0 0-1.9-4.495s14.865-6.3 14.64-2.908a10.34 10.34 0 0 0 .36 3.625z"
        opacity=".1"
      />
      <ellipse cx="137.5" cy="71.5" fill="#FBBEBE" rx="13.5" ry="14.5" />
      <path
        fill="#3F3D56"
        d="M121.372 113.258s57.83-14.072 58.063-12.061c.233 2.01 2.565 6.03 2.565 6.03l-13.525 16.585s1.633 8.041-1.632 9.8c-3.265 1.759-3.731 15.077-6.762 15.328-3.032.252-38.476-.251-38.709-2.261-.233-2.01.933-3.267 0-3.77-.933-.502-2.332-.502-1.166-3.015s1.166-13.067 1.166-13.067l-10.96-5.528s-1.503-4.682 1.23-5.482c2.734-.8 9.73-2.559 9.73-2.559z"
      />
      <path
        fill="#3F3D56"
        d="M179.426 107h2.12s6.36 4.548 8.009 8.591c1.648 4.043 7.537 9.35 8.95 10.866 1.414 1.516 20.728 15.92 20.493 17.94-.236 2.022-5.653 4.044-5.889 6.318-.235 2.274 2.356 3.285.707 3.285s-11.777-6.317-15.546-8.591c-3.769-2.275-11.542-8.844-12.484-10.613-.942-1.77-7.302-4.801-8.009-6.065-.706-1.263-11.777-7.075-11.777-7.075L179.426 107z"
      />
      <ellipse cx="139.5" cy="63" fill="#2F2E41" rx="13.5" ry="9" />
      <path
        fill="#2F2E41"
        d="M149.138 87c-6.288 2.887-11.258 3.229-14.138 3.071.098.629.149 1.266.154 1.905.334.016.694.024 1.077.024 3.181 0 7.933-.645 13.769-3.381L149.138 87z"
      />
      <rect
        width="203"
        height="131"
        x="240"
        y="162"
        fill="#3F3D56"
        rx="21.433"
      />
      <path
        fill={Colors.primary}
        d="M262 254h159v6H262zM262 238h159v6H262zM393 215h28v6h-28zM317 198h104v6H317zM262 271h79v6h-79z"
        opacity=".3"
      />
      <rect
        width="40"
        height="43"
        x="262"
        y="178"
        fill={Colors.primary}
        rx="10.165"
      />
    </g>
  </svg>
);

LoginCard.propTypes = {
  className: PropTypes.string
};

export default LoginCard;
